import Api from '@/services/Api'

export default {
  getByCampaignId(campaignId) {
    return Api().get(`campaigns/${campaignId}/coupon-history`).then(function (response) {
      return (response)
    })
  },
  getByGroupOfDiscounts(groupOfDiscounts) {
    return Api().get(`groups-of-discounts/${groupOfDiscounts}/coupon-history`).then(function (response) {
      return (response)
    })
  },
  getByGroupOfDiscountsAndPaginate(groupOfDiscounts,numberOfResultsPerPage,pageIndex) {
    return Api().get(`groups-of-discounts/${groupOfDiscounts}/coupon-history/?index=${pageIndex}&nbResult=${numberOfResultsPerPage}`).then(function (response) {
      return (response)
    })
  },
  getByCampaignIdPaginateWithFilter(campaignId,numberOfResultsPerPage,pageIndex,filterString) {
    return Api().get(`campaigns/${campaignId}/coupon-history/?index=${pageIndex}&nbResult=${numberOfResultsPerPage}${filterString}`).then(function (response) {
      return (response)
    })
  }
}




